/** Reduce backend attendance origins to the two labels HR needs in the UI. */
export const attendanceSourceLabel = (cell) => {
  if (!cell || (!cell.in_time && !cell.out_time)) return null;
  return cell.source === 'BIOMETRIC_SYNC' ? 'Biometric API' : 'Manual';
};

export default attendanceSourceLabel;
